import { render, staticRenderFns } from "./oeetab.vue.html?vue&type=template&id=579a928a"
import script from "./oeetab.controller.ts?vue&type=script&lang=js&external"
export * from "./oeetab.controller.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports